var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 15 13"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FBB731",
    d: "M6.863.524a.75.75 0 0 1 1.274 0l1.715 2.758a.75.75 0 0 0 .457.333l3.153.778a.75.75 0 0 1 .393 1.212l-2.093 2.483a.75.75 0 0 0-.174.537l.234 3.24a.75.75 0 0 1-1.031.748L7.783 11.39a.75.75 0 0 0-.566 0L4.21 12.613a.75.75 0 0 1-1.03-.748l.233-3.24a.75.75 0 0 0-.174-.537L1.145 5.605a.75.75 0 0 1 .393-1.212l3.153-.778a.75.75 0 0 0 .457-.333z"
  })));
};
export default SvgStar;